<template>
  <button class="btn btn-success" :class="btnClasses" type="button" @click="showModal">
    <i class="fa fa-check-circle"></i> Approve
  </button>

  <modal :id="modalId" title="Approve Fee Schedule">

    <div class="text-center">
      <p v-html='"Are you sure you would like to approve the Fee schedule \"" + name + "\"?"'></p>
    </div>

    <slot name="hidden"></slot>

    <template #footer>
      <button type="button" class="btn btn-default" @click="hideModal">
        <i class="fa fa-fw fa-close"></i> Cancel
      </button>

      <a :href="url" class="btn btn-primary">
        <i class="fa fa-fw fa-check"></i> Approve
      </a>
    </template>

  </modal>
</template>

<script>
import HasModal from "../mixins/HasModal";

export default {

  /**
   *
   * Confirmation dialog to confirm Fee schedule approval.
   *
   * Input properties:
   *
   * modal-id          - custom id for modal component.
   * name              - аee schedule name.
   * url               - form action URL.
   * btn-classes       - additional "Approve" button classes.
   *
   * Usage examples:
   *
   * <approve-fee-schedule-modal modal-id="..." name="..." url="..." btn-classes="...">
   *   <template #hidden>Something hidden</template>
   * </approve-fee-schedule-modal>
   */

  props: {

    // Modal dialog id.
    modalId: {
      required: false,
      type: String,
    },

    // Fee schedule name.
    name: {
      type: String,
      required: true,
    },

    // Approve url.
    url: {
      type: String,
      required: true,
    },

    // Additional "Approve" button classes.
    btnClasses: {
      type: String,
    },
  },

  mixins: [HasModal],

}
</script>
